import { formatDate } from "./DateFormat";

export const normalizeEmployee = (emp, index, currentPage, itemsPerPage) => {
  const account = emp.account || emp;
  const roleDisplay = typeof account.role === "string"
    ? account.role
    : (account.role?.displayName || account.role?.name || "Chưa có");

  return {
    stt: (currentPage - 1) * itemsPerPage + index + 1,
    _id: emp._id || emp.id,
    id: emp._id || emp.id,
    staffId: emp._id || emp.id,
    staffCode: emp.staffCode || "Chưa có",
    fullName: account.fullName || "Chưa có",
    email: account.email || account.username || "Chưa có",
    phone: emp.phone || "Chưa có",
    role: roleDisplay,
    departmentName: emp.department?.name || emp.departmentId?.name || "Chưa có",
    responsibleDepartments: Array.isArray(emp.responsibleDepartments)
      ? emp.responsibleDepartments.map((d) => (typeof d === "string" ? d : d.name || d._id))
      : [],
    joinDate: formatDate(emp.joinDate),
    status: emp.status || "Chưa có",
  };
};
